import useSWR from 'swr'

// const permitables = ['transactions', ]

const allPermissions = [
    "pos",
    "assign_pos",
    "view_pos",
    "create_pos",
    "delete_pos",
    "edit_pos",
    "branches",
    "view_branches",
    "create_branches",
    "delete_branches",
    "edit_branches",
    "overview",
    "view_all_overview",
    "view_total_revenue",
    "view_chart_information",
    "view_total_transactions",
    "view_pos_revenue",
    "view_branches_revenue",
    "transactions",
    "view_all_transactions",
    "promos",
    "view_all_promos",
    "view_ongoing_campaigns",
    "create_campaign",
    "delete_campaign",
    "view_campaign_stats",
    "download_campaign_data",
    "review",
    "view_all_reviews",
    "reply_comments"
]


const usePermissions =  (permissonName = [], errMsg) => {
    // const dataApi = await apiRequest({ method: 'get', url: 'user-mgmt/get-user-permissions' })
    allPermissions.concat(permissonName)
    const { data } = useSWR('user-mgmt/get-user-permissions')
    // console.log(data, dataApi)
    let errorMessage = errMsg ? errMsg : `Sorry you do not have permission to permission`
    let isPermitted = {}
    // permissonName.map(x => Object.assign(isPermitted, { [x]: data?.some(y => y === x) }))
    allPermissions.map(x => Object.assign(isPermitted, { [x]: data?.data?.some(y => y === x) }))
    return { data: data?.data, isPermitted, errorMessage }
}
export default usePermissions